import { useState, useEffect } from "react";
import { useNewCandidatesAgainstAJobQuery } from "../graphql/generated/graphql";

const useNewCandidatesAgainstAJob = (jobId: any) => {
  const [matchs, setMatchs]: any = useState(null);
  const { data, loading, error, refetch } = useNewCandidatesAgainstAJobQuery({
    variables: {
      jobId: jobId,
    },
    fetchPolicy: "network-only",
  });
  const loadMatches = () => {
    if (!loading && data) {
      // console.log('==> New ', data.newCandidatesAgainstAJob)
      setMatchs(data.newCandidatesAgainstAJob);
    }
  };

  useEffect(() => {
    loadMatches();
  }, [data]);

  return { matchs, refetch };
  // return matchs
};

export default useNewCandidatesAgainstAJob;
